module.exports = __webpack_public_path__ + "img/ZonaMate_icone_Metodo.7ba80dcf.svg";